import { Typography } from 'antd';
import * as React from 'react';
import { HTMLProps } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import InlineSources from './InlineSources';

const { Title, Paragraph, Text } = Typography;

const MarkdownTextRenderer: React.FC<{ text: string }> = ({
    text
}) => {
    return (
        <ReactMarkdown
            rehypePlugins={[rehypeRaw]}
            components={{
                h1: ({ children }) => (
                    <Title level={1}>
                        {children}
                    </Title>
                ),
                h2: ({ children }) => (
                    <Title level={2}>
                        {children}
                    </Title>
                ),
                h3: ({ children }) => (
                    <Title level={3}>
                        {children}
                    </Title>
                ),
                p: ({ children }) => (
                    <Paragraph style={{ margin: 0, display: 'inline' }}>
                        {children}
                    </Paragraph>
                ),
                div: (
                    props: HTMLProps<HTMLDivElement> & {
                        data?: string;
                    },
                ) => {
                    const data = props.data
                        ? JSON.parse(props.data)
                        : undefined;

                    return (
                        <div style={{ display: 'inline', whiteSpace: 'nowrap' }}>
                            {/*if last word is markdown we need this for it to convert to text*/}
                            <ReactMarkdown
                                components={{
                                    p: ({ children }) => (
                                        <Text style={{ margin: 0, display: 'inline' }} >
                                            {children}
                                        </Text>
                                    ),
                                }}
                            >
                                {data.lastWord}
                            </ReactMarkdown>
                            <InlineSources
                                citations={data.citations}
                                footnotes={data.footnotes}
                            />
                            {data.endOfTextPunctuation}
                        </div>
                    );
                },
            }}
        >
            {text}
        </ReactMarkdown>
    );
};

export default MarkdownTextRenderer;